var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCircleCross = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#F23840"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.151 7.151a.857.857 0 0 0 0 1.212L10.788 12 7.15 15.637a.857.857 0 1 0 1.212 1.212L12 13.212l3.636 3.637a.857.857 0 1 0 1.212-1.213L13.212 12l3.636-3.637a.857.857 0 0 0-1.212-1.212L12 10.788 8.363 7.15a.857.857 0 0 0-1.212 0"
}))));
export default SvgCircleCross;